export enum TribuneType {
  MANUAL = 'MANUAL',
  VIRTUAL = 'VIRTUAL',
}
